var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcSignOutMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gbbrnakbma",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y2396nz33b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#gbbrnakbma)",
    d: "M0 5.336C0 2.396 2.436 0 5.43 0h5.953C14.37 0 16.8 2.388 16.8 5.324v13.34c0 2.942-2.436 5.336-5.43 5.336H5.417C2.43 24 0 21.612 0 18.676V5.336z",
    transform: "translate(-1109 -380) translate(0 -201) translate(1090 578) translate(19 3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y2396nz33b)",
    d: "M23.735 11.346L20.32 7.855c-.353-.36-.921-.36-1.273.002-.35.363-.35.947.002 1.307l1.871 1.912H9.058c-.497 0-.9.414-.9.924 0 .511.403.924.9.924H20.92l-1.87 1.911c-.352.36-.354.945-.003 1.307.177.181.407.273.638.273.23 0 .46-.092.635-.27l3.415-3.49c.17-.174.265-.41.265-.655 0-.245-.096-.48-.265-.654",
    transform: "translate(-1109 -380) translate(0 -201) translate(1090 578) translate(19 3) rotate(-180 16.08 12)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcSignOutMenu);
export default __webpack_public_path__ + "static/media/icon-ic-sign-out-menu.ee4cb506.svg";
export { ForwardRef as ReactComponent };